module.exports = __webpack_public_path__ + "img/servo-motor.c786ec5b.svg";